import { render, staticRenderFns } from "./CommunityCommentMentionList.vue?vue&type=template&id=2fcdc65b&scoped=true&"
import script from "./CommunityCommentMentionList.vue?vue&type=script&lang=js&"
export * from "./CommunityCommentMentionList.vue?vue&type=script&lang=js&"
import style0 from "./CommunityCommentMentionList.vue?vue&type=style&index=0&id=2fcdc65b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcdc65b",
  null
  
)

export default component.exports